// extracted by mini-css-extract-plugin
export default {"sitemap":"_0hmOAOCK+fc+Da0VijUnuA=="};